<template>
  <Dashboard title="Documents + audio">
    <div id="documents">
      <Search
        v-model="search"
        v-on:handleClick="handleSearchButton"
        class="media-filter"
      />

      <Dropdown :title="selectedDateLabel">
        <ul class="dropdown--content--list">
          <li v-if="this.$route.query.yearmonth !== ''">
            <span
              v-on:click="handleClearDate"
              class="dropdown--content--list--click"
            >
              Clear date
            </span>
          </li>

          <li
            v-for="(item, index) in listDates"
            v-bind:key="item.index"
            v-bind:data-index="index"
          >
            <span
              v-on:click="handleYearMonth(item)"
              class="dropdown--content--list--click"
            >
              {{ `${item.label}` }}
            </span>
          </li>

          <li v-if="listDates.length === 0">No results found 😟</li>
        </ul>
      </Dropdown>

      <Dropdown
        class="dropdown-type"
        :title="selectedFiletypeLabel"
      >
        <ul class="dropdown--content--list">
          <li v-if="this.$route.query.extension !== ''">
            <span
              v-on:click="handleClearType"
              class="dropdown--content--list--click"
            >
              Clear type
            </span>
          </li>

          <li
            v-for="(item, index) in listFiletypes"
            v-bind:key="item.index"
            v-bind:data-index="index"
          >
            <span
              v-on:click="handleType(item)"
              class="dropdown--content--list--click"
            >
              {{ `${item.label}` }}
            </span>
          </li>

          <li v-if="listFiletypes.length === 0">No results found 😟</li>
        </ul>
      </Dropdown>

      <p class="storage--switch-form-text storage--switch-form-text-cloud">Tag cloud:</p>

      <SwitchForm
        v-model="tagCloud"
        @input="toggleTagCloud"
      />

      <Button
        title="Add"
        to=""
        active=true
        showAddIcon=true
        class="storage--button"
        v-on:handleClick="handleModalUpload"
      />

      <Cloud
        v-if="tagCloud"
        :data="words"
        :fontSizeMapper="fontSizeMapper"
        :onWordClick="cloudClick"
      />

      <div
        v-if="
          $route.query.tag !== ''
          && tagCloud
        "
        class="selected-tag"
      >
        <p>Selected tag: {{ $route.query.tag }}</p>
      </div>

      <Button
        v-if="
          $route.query.tag !== ''
          && tagCloud
        "
        title="Clear tag"
        to=""
        active=true
        class="storage--clear-tag-button"
        v-on:handleClick="resetTagSearch"
      />

      <StorageComponent
        :records="records"
        :pages="pages"
        v-on:handleLeftButton="handlePrevButton"
        v-on:handleRightButton="handleNextButton"
      >
        <Table
          recordsfoundishidden=true
          :data="documents"
          :isloading="isLoading"
        >
          <template v-slot:titles>
            <th>ID</th>
            <th>Title</th>
            <th>Created</th>
            <th>Type</th>
          </template>

          <template v-slot:row>
            <tr
              class="table--content"
              v-for="(item, index) of documents"
              v-bind:key="index"
              v-on:click="handleModal(item, index)"
            >
              <TdId :id="item.id"/>

              <td>
                {{ item.title}}
                <br v-if="item.title.length > 0"/>
                <a
                  v-on:click.stop
                  :href="item.url"
                  target="_blank"
                  class="filename-link">
                    {{ item.clientfilename }}
                </a>
              </td>

              <TdTitle :title="item.createddate"/>

              <td>
                {{ fileType(item.serverfilename) }}
              </td>
            </tr>
          </template>
        </Table>
      </StorageComponent>
    </div>

    <Modal
      closeIcon="true"
      v-on:close="handleModalUpload"
      v-if="!modalUpload.isHidden"
    >
      <template v-slot:title>
        <h3>Upload documents</h3>
      </template>

      <template v-slot:content>
        <Uppy
          modelClass=""
          modelId=""
          collection=""
          endpoint="index.cfm?act=documents.item"
          path="nhc/boostme/docs/"
          :allowedFileTypes="['*/*']"
        />
      </template>
    </Modal>

    <Modal
      closeIcon="true"
      v-on:close="handleModal"
      v-if="!modal.isHidden"
    >
      <template v-slot:title>
        <h3>Document detail</h3>
      </template>

      <template v-slot:content>
        <div class="row">
          <Input
            class="col-24"
            placeholder="Title"
            type="text"
            :value="modal.data.title"
            v-model="modal.data.title"
          />

          <Input
            class="col-24"
            placeholder="Description"
            type="text"
            :value="modal.data.description"
            v-model="modal.data.description"
          />

          <div class="col-24">
            <p class="form-label">Tags</p>

            <multiselect
              v-model="tagsArraySelected"
              tag-placeholder="Add this as new tag"
              placeholder="Search or add a tag"
              label="name"
              track-by="code"
              :options="tagsArray"
              :multiple="true"
              :taggable="true"
              @tag="addTag">
            </multiselect>

          </div>

          <div class="col-24 input">
            <p>Filename</p>

            <span><a
                    :href="modal.data.url"
                    target="_blank"
                    class="filename-link">
                      {{ modal.data.clientfilename }}
                  </a>
            </span>
          </div>

          <div class="col-24 input">
            <p>Date created</p>

            <span>{{ modal.data.createddate }}</span>
          </div>

          <div class="col-24 input">
            <p>Filesize</p>

            <span>{{ modal.data.filesize }}</span>
          </div>

          <div class="col-24 input">
            <p>Url</p>

            <span>{{ modal.data.url }}</span>
          </div>

          <div class="col-24">
            <ButtonForm
              title="Save document"
              v-on:handleClick="handleModalButton()"
            />

            <ButtonForm
              title="Delete document"
              danger="true"
              v-on:handleClick="handleDeleteButton()"
            />
          </div>
        </div>
      </template>
    </Modal>
  </Dashboard>
</template>

<script>
  import { API } from '../../services/api.ts'
  import Dashboard from '../../components/dashboard/dashboard.vue'
  import NoApplicationSelected from '../../components/error/noApplicationSelected.vue'
  import Search from '../../components/form/search.vue'
  import Dropdown from '../../components/dropdown/dropdown.vue'
  import SwitchForm from '../../components/form/switch.vue'
  import Button from '../../components/buttons/button.vue'
  import StorageComponent from '../../components/storage/storage.vue'
  import RatioBlockImage from '../../components/ratioBlock/ratioBlockImage.vue'

  import Table from '../../components/table/table.vue'
  import TdTitle from '../../components/table/td/title.vue'
  import TdId from '../../components/table/td/id.vue'
  import TdButtons from '../../components/table/td/buttons.vue'
  import RoundedButton from '../../components/buttons/roundedButton.vue'

  import Modal from '../../components/modal/modal.vue'
  import Input from '../../components/form/input.vue'
  import ButtonForm from '../../components/form/button.vue'
  import Uppy from '../../components/uppy/uppy.vue'
  import Cloud from 'vue-d3-cloud'
  import Multiselect from 'vue-multiselect'
  import moment from 'moment';


  export default {
    name: 'Storage',
    components: {
      Dashboard,
      NoApplicationSelected,
      Search,
      Dropdown,
      SwitchForm,
      Button,
      StorageComponent,
      RatioBlockImage,
      Table,
      TdTitle,
      TdId,
      TdButtons,
      RoundedButton,
      Modal,
      Input,
      ButtonForm,
      Uppy,
      Cloud,
      Multiselect
    },
    data () {
      return {
        tagCloud: false,
        words: [],
        fontSizeMapper: word => this.cloudWordSizeValue(Math.log2(word.value) * 5),
        switchData: this.$route.query.used,
        selectedApplicationId: localStorage.selectedApplicationId,
        listDates: [],
        listFiletypes: [],
        search: '',
        selectedDateLabel: 'Select date',
        selectedFiletypeLabel: 'Select type',
        pages: 0,
        records: 0,
        documents: [],
        modalUpload: {
          isHidden: true
        },
        modal: {
          isHidden: true,
          title: '',
          id: 0,
          index: 0,
          data: {
            clientfilename: '',
            createddate: '',
            filesize: '',
            url: '',
            title: '',
            description: '',
            tags: ''
          }
        },
        isLoading: false,
        tagsArray: [],
        tagsArraySelected: []
      }
    },
    computed: {
      computedList: function () {
        const newQuery = this.modal.data.tags.split(/[\s,]+/);

        return this.tags.filter(function (item) {
          return item.name.toLowerCase().indexOf(newQuery[newQuery.length-1].toLowerCase()) !== -1
        })
      }
    },
    methods: {
      cloudWordSizeValue: function(value) {
        if (value < 11) {
          value = 11;
        }

        return value;
      },
      cloudClick: function(word) {

        this.$router.push({ query: {
          page: 1,
          used: this.$route.query.used,
          tag: word.text,
          yearmonth: this.$route.query.yearmonth,
          keyword: this.$route.query.keyword,
          extension: this.$route.query.extension
        }})

        this.loadData();
      },
      showList() {
        let allTagList = document.querySelectorAll('.tag--list');
        let tagList = this.$el.querySelector('.tag--list');

        tagList.style.display = 'block';
      },
      toggleTagCloud(value) {
        if (!value) {
          this.resetTagSearch()
        }
      },
      addTag (newTag) {
        const tag = {
          name: newTag,
          code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
        }

        this.tagsArraySelected.push(tag)
        this.tagsArray.push(tag)
      },
      resetTagSearch: function() {
        this.$router.push({ query: {
          page: 1,
          used: this.$route.query.used,
          tag: '',
          yearmonth: this.$route.query.yearmonth,
          keyword: this.$route.query.keyword
        }})

        this.loadData();
      },
      handleSwitch: function() {
        if (this.$route.query.used === 'false' || this.$route.query.used === false) {
          this.$router.push({ query: {
            page: 1,
            used: true,
            tag: this.$route.query.tag,
            yearmonth: this.$route.query.yearmonth,
            keyword: this.$route.query.keyword,
            extension: this.$route.query.extension
          }})
        } else {
          this.$router.push({ query: {
            page: 1,
            used: false,
            tag: this.$route.query.tag,
            yearmonth: this.$route.query.yearmonth,
            keyword: this.$route.query.keyword,
            extension: this.$route.query.extension
          }})
        }

        this.loadData();
      },
      handlePrevButton: function() {
        this.$router.push({ query: {
          page: parseInt(this.$route.query.page) - 1,
          used: this.$route.query.used,
          tag: this.$route.query.tag,
          yearmonth: this.$route.query.yearmonth,
          keyword: this.$route.query.keyword,
          extension: this.$route.query.extension
        }})

        this.loadData();
      },
      handleNextButton: function() {
        this.$router.push({ query: {
          page: parseInt(this.$route.query.page) + 1,
          used: this.$route.query.used,
          tag: this.$route.query.tag,
          yearmonth: this.$route.query.yearmonth,
          keyword: this.$route.query.keyword,
          extension: this.$route.query.extension
        }})

        this.loadData();
      },
      handleClearDate: function() {
        let dropdowns = document.getElementsByClassName('dropdown--list');
        let dropdownButtons = document.getElementsByClassName('dropdown--button');

        for (let i = 0; i < dropdowns.length; i++) {
          dropdowns[i].classList.remove('dropdown--show');
          dropdownButtons[i].classList.remove('dropdown--button-active');
        }

        this.selectedDateLabel = 'Select date'

        this.$router.push({ query: {
          page: 1,
          used: this.$route.query.used,
          tag: this.$route.query.tag,
          yearmonth: '',
          keyword: this.$route.query.keyword,
          extension: this.$route.query.extension
        }})

        this.loadData();
      },
      handleClearType: function() {
        let dropdowns = document.getElementsByClassName('dropdown--list');

        let dropdownButtons = document.getElementsByClassName('dropdown--button');

        for (let i = 0; i < dropdowns.length; i++) {
          dropdowns[i].classList.remove('dropdown--show');
          dropdownButtons[i].classList.remove('dropdown--button-active');
        }

        this.selectedFiletypeLabel = 'Select type'

        this.$router.push({ query: {
          page: 1,
          used: this.$route.query.used,
          tag: this.$route.query.tag,
          yearmonth: this.$route.query.yearmonth,
          keyword: this.$route.query.keyword,
          extension: ''
        }})

        this.loadData();
      },
      handleYearMonth: function(date) {
        let dropdowns = document.getElementsByClassName('dropdown--list');
        let dropdownButtons = document.getElementsByClassName('dropdown--button');

        for (let i = 0; i < dropdowns.length; i++) {
          dropdowns[i].classList.remove('dropdown--show');
          dropdownButtons[i].classList.remove('dropdown--button-active');
        }

        this.selectedDateLabel = date.label

        this.$router.push({ query: {
          page: 1,
          used: false,
          tag: this.$route.query.tag,
          yearmonth: date.date,
          keyword: this.$route.query.keyword,
          extension: this.$route.query.extension
        }})

        this.loadData();
      },
      handleType: function(type) {
        let dropdowns = document.getElementsByClassName('dropdown--list');

        let dropdownButtons = document.getElementsByClassName('dropdown--button');

        for (let i = 0; i < dropdowns.length; i++) {
          dropdowns[i].classList.remove('dropdown--show');
          dropdownButtons[i].classList.remove('dropdown--button-active');
        }

        this.selectedFiletypeLabel = type.label
        this.$router.push({ query: {
          page: 1,
          used: this.$route.query.used,
          tag: this.$route.query.tag,
          yearmonth: this.$route.query.yearmonth,
          keyword: this.$route.query.keyword,
          extension: type.extension
        }})

        this.loadData();
      },
      handleSearchButton: function() {
        this.$router.push({ query: {
          page: 1,
          used: this.$route.query.used,
          tag: this.$route.query.tag,
          yearmonth: this.$route.query.yearmonth,
          keyword: this.search,
          extension: this.$route.query.extension
        }})

        this.loadData();
      },
      fileType: function(serverfilename) {
        if (serverfilename.includes('.pdf')) {
          return 'pdf'
        } else if (serverfilename.includes('.mp3')) {
          return 'mp3'
        }

        return serverfilename;
      },
      handleModalUpload: function(data) {
        if (this.modalUpload.isHidden === true) {
          this.modalUpload.isHidden = false;
        } else {
          // This.modalUpload.isHidden = true;
          location.reload();
        }
      },
      handleModal: function(data, index) {
        if (this.modal.isHidden === true) {
          this.modal.id = data.id;
          this.modal.index = index;

          API.get(
            `index.cfm?act=documents.item&id=${data.id}`
          ).then(
            response => {
              console.log(response.data.data);

              const tags = '';

              this.tagsArraySelected = []

              for (let i = 0; i < response.data.data.tags.length; i++) {
                const element = response.data.data.tags[i];

                this.tagsArraySelected.push(
                  {
                    name: element.name,
                    code: element.name
                  }
                );
              }

              this.modal.data.clientfilename = response.data.data.clientfilename;
              this.modal.data.createddate = moment.utc(response.data.data.createddate).format('D MMMM YYYY HH:mm')
              this.modal.data.filesize = response.data.data.filesize;
              this.modal.data.url = response.data.data.url;

              this.modal.data.tags = tags.substring(0, tags.length - 2);
              this.modal.data.title = response.data.data.title;
              this.modal.data.description = response.data.data.description;

              this.modal.isHidden = false;
            }
          )
        } else {
          this.modal.isHidden = true;
        }
      },
      handleModalButton: function() {
        let tags = ""

        for (let i = 0; i < this.tagsArraySelected.length; i++) {
          const item = this.tagsArraySelected[i];

          tags += `${item.name},`
        }

        API.patch(
          `index.cfm?act=documents.item&id=${this.modal.id}`,
          {
            title: this.modal.data.title,
            description: this.modal.data.description,
            tags: tags.replace(/\s*,\s*/g, ",")
          }
        ).then(
          response => {
            console.log(response);
            this.documents[this.modal.index].title = response.data.data.title;
            this.modal.isHidden = true;
          }
        )
      },
      handleDeleteButton: function() {
        if (confirm("Are you sure you want to delete this page?")) {
          API.delete(
            `index.cfm?act=documents.item&id=${this.modal.id}`
          ).then(
            response => {
              console.log(response);
              this.documents.splice(this.modal.index, 1);
              this.modal.isHidden = true;
            }
          )
        }
      },
      loadData: function() {
        API.post(
          `index.cfm?act=documents.search`,
          {
            page: parseInt(this.$route.query.page),
            used: this.$route.query.used,
            tag: this.$route.query.tag,
            yearmonth: this.$route.query.yearmonth,
            keyword: this.$route.query.keyword,
            extension: this.$route.query.extension
          }
        ).then(
          response => {
            const calcPages = Math.ceil(response.data.data.totalItems / response.data.data.itemsPerPage);

            this.pages = calcPages
            this.documents = response.data.data.items
            for (let i = 0; i < this.documents.length; i++) {
              this.documents[i].createddate = moment.utc(this.documents[i].createddate).format('ddd D MMM YYYY HH:mm')
            }
            this.records = response.data.data.totalItems

            console.log(response);
          }
        )

        API.post(
          `index.cfm?act=documents.filteroptions`,
        ).then(
          response => {
            this.listDates = response.data.data.dates;
            for(let i = 0; i < this.listDates.length; i++) {
              this.listDates[i].label = this.listDates[i].date.replace(/(\d{4})/g, '$1-') + ' (' + this.listDates[i].total + ')'
            }

            this.listFiletypes = response.data.data.extensions;
            for(let i = 0; i < this.listFiletypes.length; i++) {
              this.listFiletypes[i].label = this.listFiletypes[i].extension + ' (' + this.listFiletypes[i].total + ')'
            }
          }
        )
      }
    },
    mounted() {
      const self = this;

      API.get(
        `index.cfm?act=tags.list`,
      ).then(
        response => {
          for (let i = 0; i < response.data.data.length; i++) {
            const element = response.data.data[i];

            this.tagsArray.push(
              {
                name: element.name,
                code: element.name
              }
            );

          }
        }
      ).catch(function (error) {
        if (error.response.status === 403) {
          localStorage.removeItem('selectedApplicationName');
          localStorage.removeItem('selectedApplicationId');
          self.selectedApplicationId = null
        }
      });

      API.get(
        `index.cfm?act=tags.cloud&media=docs`,
      ).then(
        response => {
          for (let i = 0; i < response.data.data.length; i++) {
            const item = response.data.data[i];

            this.words.push(
              {
                text: item.name,
                value: item.amount
              }
            )
          }
        }
      )

      this.loadData();
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/mediaQueries.scss";

  #documents {
    .storage--switch-form-text-cloud {
      @include media-md {
        margin-left: 15px;
      }
    }

    .wordCloud {
      background-color: white;
      border-radius: 3px;
      height: 300px;
      width: 100%;
      float: left;
      margin-top: 15px;

      svg {
        width: 100% !important;
        height: 100% !important;

        g {
          transform: translate(50%, 50%) !important;
        }
      }

      text {
        cursor: pointer;
      }
    }

    .dropdown {
      float: left;
      margin-right: 15px;

      @include media-md {
        width: calc(50% - 7.5px);
      }
    }

    .dropdown {
      width: 170px;

      @include media-md {
        margin-right: 0;
      }
    }

    .storage--switch-form-text {
      font-weight: bold;
      float: left;
      margin-right: 10px;
      margin-top: 5px;
    }

    .switch {
      margin-top: 5px;
      float: left;
    }

    .storage--switch-form-text,
    .switch {
      @include media-md {
        margin-top: 20px;
      }
    }

    .storage--button {
      float: right;

      @include media-md {
        margin-top: 15px;
      }
    }

    .selected-tag {
      float: left;
      margin-top: 22px;
      font-weight: bold;
    }

    .storage--clear-tag-button {
      float: left;
      margin-left: 15px;
      margin-top: 15px;
    }

    .table {
      float: left;
    }

    .table--content {
      cursor: pointer;
    }

    .dropdown-type {

      @include media-md {
        margin-top: 15px;
      }
    }

    .form-label {
      font-weight: bold;
      padding-bottom: 15px;
    }
  }

  .filename-link {
    text-decoration: underline;
  }
</style>